import React, { useEffect, useRef, useState } from "react";
import { stringToHslColor, getDarkerHslColor } from '../../helper/extension';
import { useNavigate, useSearchParams } from "react-router-dom";
import { doctorProfileRequestState } from '../../services/data.searvice';
import { Image, Map, Reviews } from "../../components/componentIndex";
import { useRecoilState } from "recoil";
import { Button } from "../../common/commonIndex";
import StarIcon from '../../assets/images/dashboard/star.svg';
import DoctorPhoto from '../../assets/images/doctorProfile/doctorPhoto.svg';
import MarkLocationIcon from '../../assets/images/doctorProfile/map-marker.svg';
import ModemIcon from '../../assets/images/doctorProfile/fellowship-icon.svg';
import MonitorIcon from '../../assets/images/doctorProfile/residency-icon.svg';
import MedicalCaseIcon from '../../assets/images/doctorProfile/med-school-icon.svg';
import DatePicker from "react-datepicker";
import BackIcon from '../../assets/images/doctorProfile/right-arrow.svg';
import CalendarIcon from '../../assets/images/doctorProfile/calender-icon.svg';
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import PatientService from 'services/API/patientService';
import ReviewService from '../../services/API/reviewService';
import 'react-datepicker/dist/react-datepicker.css';

const DoctorProfile = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams(); // Get the search parameters
    let today = searchParams.get('date') ? new Date(searchParams.get('date')) : new Date();
    const [calenderValue, setCalenderValue] = useState();
    const [selectedDate, setSelectedDate] = useState();
    const [colonosCopy, setColonosCopy] = useState(true);
    const [endosCopy, setEndosCopy] = useState(false);
    const [selectedTime, setSelectedTime] = useState({ location: '', time: '' });
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isReview, setIsReview] = useState(false);
    const [isAddressTime, setIsAddressTime] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isReviewLoading, setIsReviewLoading] = useState(false);
    const [isChangeMonth, setIsChangeMonth] = useState(false);
    const [userId, setUserId] = useState(null);
    const [doctorDetails, setDoctorDetails] = useState({});
    const [doctorAvailability, setDoctorAvailability] = useState({});
    const [notAvailableDate, setNotAvailableDate] = useState([]);
    const [reviewsList, setFilteredReviews] = useState([]);
    const [reviewsProgress, setReviewsProgress] = useState([]);
    const [doctorProfileRequest, setDoctorProfileRequest] = useRecoilState(doctorProfileRequestState);
    const [highlightedDates, setHighlightedDates] = useState([]);
    const [totalReviews, setTotalReviews] = useState({});

    const calenderOnChange = (date) => {
        setIsChangeMonth(false);
        setCalenderValue(date);
        setSelectedDate(date);
        setIsAddressTime(true);
        getDoctorAvailability(date);
    };

    const handleMonthChange = (event, date) => {
        event.preventDefault(); // Simulated preventDefault()
        const selectedFindDate = date?.getMonth() === today?.getMonth() ? today : getFirstDateOfMonth(date);
        const findSearchParamDate = new Date(searchParams.get('date'));
        if (date?.getMonth() !== today?.getMonth() && date?.getMonth() !== findSearchParamDate.getMonth()) {
            setIsChangeMonth(true);
        }
        setCalenderValue(selectedFindDate);
        getNotAvailableDates(selectedFindDate);
    }

    const getFirstDateOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    };

    useEffect(() => {
        setCalenderValue(null);
        // setCalenderValue(new Date(searchParams.get('date')));
        setUserId(searchParams.get('fkUserId'));
        getDoctorDetails();
        getNotAvailableDates(null);
        setHighlightedDates([new Date(searchParams.get('date'))]);
        getTotalReview();
        getReviews();
    }, []);

    const convertDate = (dateString) => {
        const date = new Date(dateString); // Parse the date string
        // Get the parts of the date
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        // Format as 'YYYY/MM/DD'
        return `${year}/${month}/${day}`;
    };

    const getDoctorAvailability = async (date) => {
        try {
            let formattedDate = '';
            formattedDate = convertDate(date);
            let requestObject = {
                fkUserId: userId || searchParams.get('fkUserId'),
                date: formattedDate
            }
            setSelectedTime({ location: '', time: '' });
            setIsLoading(true);
            const response = await PatientService.getDoctorAvailability(requestObject);
            if (response?.statusCode === 200) {
                setDoctorAvailability(response?.result);
            }
            setIsLoading(false);
            return response;
        } catch (error) {
            setIsLoading(false);
            console.error("Login failed: ", error);
        }
    }
    const getNotAvailableDates = async (monthFirstDate) => {
        try {
            let findDate = monthFirstDate ? monthFirstDate : calenderValue || searchParams.get('date')
            let formattedDate; // = convertDate(findDate);

            if (findDate) {
                formattedDate = convertDate(findDate);
            } else {
                formattedDate = convertDate(new Date);
            }
            let requestObject = {
                fkUserId: userId || searchParams.get('fkUserId'),
                date: formattedDate //calenderValue?.toLocaleDateString() || searchParams.get('date')
            }
            const response = await PatientService.getNotAvailableDates(requestObject);
            if (response?.statusCode === 200) {
                setNotAvailableDate(response?.result);
                localStorage.setItem('notAvailableDate', JSON.stringify(response?.result));
                // const foundDate = response?.result?.includes(formattedDate.replaceAll('/', '-')+'T00:00:00');
                // setDoctorAvailability([]);
                // if(!foundDate){
                //     getDoctorAvailability(findDate);
                // }
            }
            return response;
        } catch (error) {
            console.error("Login failed: ", error);
        }
    }
    const getDoctorDetails = async () => {
        try {
            const response = await PatientService.getDoctorDetails(userId || searchParams.get('fkUserId'));
            if (response?.statusCode === 200) {
                setDoctorDetails(response?.result);
            }
            setIsLoading(false);
            return response;
        } catch (error) {
            setIsLoading(false);
            console.error("Login failed: ", error);
        }
    }

    const getFormattedAddress = (address, city, state) => {
        if (!address) { return };
        const cityExists = address?.includes(city);

        if (cityExists) {
            return address; // Address already contains city and state, return as is
        }

        return `${address}${cityExists ? "" : `, ${city}`}${cityExists ? "" : `, ${state}`}`;
    };

    const dayClassName = (date) => {
        const isToday =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();

        const selectedMonth = calenderValue && calenderValue?.getFullYear() !== 1970 ? calenderValue.getMonth() : today.getMonth();
        const selectedYear = calenderValue && calenderValue?.getFullYear() !== 1970 ? calenderValue.getFullYear() : today.getFullYear();

        // Add class if the date is outside the selected month or before today
        if (
            (date.getMonth() !== selectedMonth || date.getFullYear() !== selectedYear) ||
            (date < today && !isToday)
        ) {
            return 'disabled-before-today'; // Class for days before today or outside selected month
        }

        return ''; // No class for valid days in the selected month and today itself
    };

    const handleColonosCopy = (e) => {
        e.preventDefault();
        setColonosCopy(!colonosCopy);
        setEndosCopy(!endosCopy);
    }
    const handleConfirmRequest = (e) => {
        e.preventDefault();
        let selectedTimes = doctorAvailability?.availableSlots?.map((center) => center.slots.find((slot) => slot.startTime === selectedTime?.time)).find(Boolean);
        // const targetTime = "9:00 AM";
        const result = doctorAvailability.availableSlots.find((slotGroup) =>
            slotGroup.slots.some((slot) => slot.startTime === selectedTime?.time)
        );
        doctorDetails.surgeryCenter = result.name;
        doctorDetails.organizationName = result.name;
        doctorDetails.surgeryCenterAddress = result.address;
        let object = {
            doctorData: doctorDetails,
            selectedDate: calenderValue,
            times: selectedTimes,
            reviewList: reviewsList && reviewsList?.length > 0 ? `${reviewsList[0]?.overall?.toFixed(1)} ${'(' + reviewsList.length + ')'}` : null,
        }
        setDoctorProfileRequest(object);
        navigate('/confirm-request?');
    }

    const handleEndosCopy = (e) => {
        e.preventDefault();
        setEndosCopy(!endosCopy);
        setColonosCopy(!colonosCopy);
    }

    const handleSelectTime = (location, time) => {
        setSelectedTime({ location, time });
        closeFullScreen();
        setIsAddressTime(false);
    };

    const handleBackScreen = (e) => {
        e.preventDefault();
        window.history.back();
    }

    const openFullScreen = () => {
        setIsFullScreen(true);
    };
    const closeFullScreen = () => {
        setIsFullScreen(false);
        setIsAddressTime(false);
    };
    const openReviewScreen = () => {
        setIsReview(true);
    };

    const closeReviewScreen = () => {
        setIsReview(false);
    };


    // Parse the date strings into Date objects
    const disabledDates = notAvailableDate?.map((date) => new Date(date));

    // Filter function to disable specific dates
    const isDateDisabled = (date) => {
        return disabledDates.some(
            (disabledDate) =>
                disabledDate.getFullYear() === date.getFullYear() &&
                disabledDate.getMonth() === date.getMonth() &&
                disabledDate.getDate() === date.getDate()
        );
    };

    const checkDate = (event) => {
        let targetDate = event ? new Date(event).toISOString()?.split('.')[0] : null;
        if (targetDate) {
            const exists = notAvailableDate?.map(date => date === targetDate)?.includes(true);
            return exists;
        } else {
            return false;
        }
    }
    const getTotalReview = async () => {
        try {
        setIsReviewLoading(true);
        const response = await ReviewService.getDocReviewCount(searchParams.get('fkUserId'));
        if (response?.data) {
            setTotalReviews(response?.data);
        }
        setIsReviewLoading(false);
    } catch (error) {
        setIsReviewLoading(false);
        console.error("Error fetching reviews: ", error);
    } finally {
        setIsReviewLoading(false);
    }
    }
    const getReviews = async () => {
        try {
            setIsReviewLoading(true);
            const response = await ReviewService.getReview(searchParams.get('fkUserId'));
            if (response?.data?.length > 0) {
                const keys = [
                    "instructions",
                    "location",
                    "wait_time",
                    "cleanliness",
                    "bedside_manner",
                    "bowel_prep",
                ];

                const result = keys.map((key) => ({
                    name: key,
                    review: response?.data[0][key],
                }));

                setFilteredReviews(response.data);
                setReviewsProgress(result);
            }
            setIsReviewLoading(false);
        } catch (error) {
            setIsReviewLoading(false);
            console.error("Error fetching reviews: ", error);
        } finally {
            setIsReviewLoading(false);
        }
    };


    return (
        <div className="custom-container doctor-profile-content">
            <div className="profile-card">
                <div className="profile-info">
                    {doctorDetails?.profileSignedUrl ? (
                        <div className="doctor-photo" style={{
                            backgroundImage: `url(${doctorDetails?.profileSignedUrl || DoctorPhoto})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}>

                            <div className="circle-btn back-to-prev-screen" onClick={handleBackScreen}>
                                <Image imgUrl={BackIcon} altText={''} className={''} />
                            </div>
                        </div>
                    ) : (
                        <div
                            className="doctor-photo doctor-shortname"
                            style={{
                                backgroundColor: stringToHslColor(
                                    `${doctorDetails?.firstName?.charAt(0) ?? ""}${doctorDetails?.lastName?.charAt(0) ?? ""}`
                                ),
                                border: `2px solid ${getDarkerHslColor(
                                    `${doctorDetails?.firstName?.charAt(0) ?? ""}${doctorDetails?.lastName?.charAt(0) ?? ""}`
                                )}`,
                            }}
                        >
                            <p className="short-name">{`${doctorDetails?.firstName?.charAt(0) ?? ""}${doctorDetails?.lastName?.charAt(0) ?? ""}`}</p>
                            <div className="circle-btn back-to-prev-screen" onClick={handleBackScreen}>
                                <Image imgUrl={BackIcon} altText="" className="" />
                            </div>
                        </div>

                    )}

                    <div className="doctor-details">
                        <h2 className="doctor-name">{doctorDetails?.firstName} {doctorDetails?.lastName ? doctorDetails?.lastName + ' ,' : ''} {doctorDetails?.credential}</h2>
                        <p className="specialization">{doctorDetails?.specialtyName}</p>
                        <div className="rating">
                            {isReviewLoading ? (
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only"></span>
                                </div>
                            ) : (
                                <>
                                    {totalReviews?.count !== '0' && (
                                        <>
                                            <Image imgUrl={StarIcon} altText={'star'} className={'star me-2'} />
                                            <span>{isNaN(totalReviews?.overAllAvg) ?  '0.0' : parseInt(totalReviews?.overAllAvg)?.toFixed(1) || '0.0'}</span> <a href="#" className="ms-2" onClick={openReviewScreen}>{totalReviews?.count} reviews</a>
                                            {/* <span>{reviewsList[0]?.overall?.toFixed(1) || '0.0'}</span> <a href="#" className="ms-2" onClick={openReviewScreen}>{reviewsList?.length} reviews</a> */}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="divider"></div>
                        <div className="training">
                            <h3 className="training-title">Training</h3>
                            <ul>
                                <li> <Image imgUrl={ModemIcon} altText={'modem'} className={'modem fellowship-icon'} /> {`Fellowship, ${doctorDetails?.fellowship}`}</li>
                                <li> <Image imgUrl={MonitorIcon} altText={'monitor'} className={'monitor'} />{`Residency, ${doctorDetails?.residency}`}</li>
                                <li> <Image imgUrl={MedicalCaseIcon} altText={'medicalCase'} className={'medical-case'} /> {`Medical school, ${doctorDetails?.medicalSchool}`}</li>
                            </ul>
                        </div>
                        <div className="location-details">
                            {doctorDetails && doctorDetails?.surgeryCenterLatitude && doctorDetails?.surgeryCenterLongitude && (
                                <>
                                    <div className="divider"></div>
                                    <div className="my-4">
                                        <h3 className="d-flex align-items-start location-title ">Office Location</h3>
                                        <p className="d-flex align-items-start location"> <Image imgUrl={MarkLocationIcon} altText={'marker'} className={'me-2'} />{getFormattedAddress(doctorDetails?.address, doctorDetails?.cityName, doctorDetails?.stateName)} </p>
                                    </div>
                                    <Map position={[doctorDetails?.surgeryCenterLatitude, doctorDetails?.surgeryCenterLongitude]} />
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="mt-5 mt-md-0">
                    <div className="mobile-screen">
                        <div className="d-flex justify-content-between align-items-center w-300">
                            <div className="d-flex align-items-start w-185" onClick={openFullScreen}>
                                <Image imgUrl={CalendarIcon} altText={'date picker'} className={'pe-2'} />
                                <a href="#" onClick={(e) => e.preventDefault()} className="ms-2 text-nowrap" >
                                    {selectedTime?.time ? (
                                        <>
                                            {(calenderValue || today).toLocaleDateString('en-US',
                                                {
                                                    month: 'short',
                                                    day: '2-digit'
                                                })} {selectedTime.time ? 'at ' + selectedTime.time : ''}
                                        </>
                                    ) : (
                                        <>
                                            Choose a date
                                        </>
                                    )}
                                </a>
                            </div>
                            <Button btnClass={`${selectedTime.location !== '' ? 'btn-primary' : 'ms-4 btn-light'}`}
                                btnName={'Request'}
                                btnType={'button'}
                                onClick={handleConfirmRequest}
                                isDisabled={selectedTime.location !== '' ? true : false}
                            />
                        </div>
                    </div>

                    {/* Full-screen DatePicker */}

                    <div className="destop-tablet-screen">
                        <div className="doctor-profile-datepicker-box">
                            <div className="justify-content-center mb-5">

                                <Button btnClass={`colonos-copy-btn me-2 ${colonosCopy ? 'btn-primary' : 'button-secondary ms-2'}`}
                                    btnName={'Colonoscopy'}
                                    btnType={'button'}
                                    onClick={handleColonosCopy}
                                    isDisabled={true}
                                />
                                {/* <Button btnClass={`colonos-copy-btn me-2 ${endosCopy ? 'btn-primary' : 'button-secondary ms-2'}`}
                                    btnName={'Endoscopy'}
                                    btnType={'button'}
                                    onClick={handleEndosCopy}
                                    isDisabled={true}

                                /> */}
                            </div>
                            <div className="calendar-container doctor-profile margin-y-50">
                                <DatePicker
                                    onChange={(date) => calenderOnChange(date)}
                                    selected={isChangeMonth ? checkDate(selectedDate) ? '' : selectedDate : checkDate(calenderValue) ? '' : calenderValue}
                                    inline
                                    filterDate={(date) => !isDateDisabled(date)} // Disable specific dates
                                    dayClassName={dayClassName} //
                                    highlightDates={calenderValue ? '' : highlightedDates}
                                    calendarStartDay={0}
                                    locale="it"
                                    onMonthChange={(date) => {
                                        const fakeEvent = { preventDefault: () => console.log("Prevented default action") };
                                        handleMonthChange(fakeEvent, date);
                                    }}
                                    minDate={new Date()}
                                />
                            </div>

                            <div className="">
                                <div>
                                    {isLoading ? (
                                        <div className="loader slot-loader"></div>
                                    ) : (
                                        <>
                                            {doctorAvailability?.availableSlots?.map((availability, index) => (
                                                <>
                                                    <div className="d-flex justify-content-start align-items-center">
                                                        <Image
                                                            imgUrl={MarkLocationIcon}
                                                            altText="mark location"
                                                            className="me-3"
                                                        />
                                                        <p className="mb-0 location">{availability.name}</p>
                                                    </div>

                                                    <div className="justify-content-between margin-y-14 slot slot-scroll">
                                                        {availability?.slots.map((time, timeIndex) => (
                                                            <span
                                                                key={timeIndex}
                                                                className={`badge ${selectedTime.location === 'Surgery' && selectedTime.time === time.startTime
                                                                    ? 'badge-selected badge-primary'
                                                                    : ''
                                                                    }`}
                                                                onClick={() => handleSelectTime('Surgery', time.startTime)}
                                                            >
                                                                {time.startTime}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </>
                                            ))}
                                        </>
                                    )
                                    }
                                </div>
                                <div className="mb-3">
                                    <Button btnClass={'btn-primary '}
                                        btnName={'Request'}
                                        btnType={'button'}
                                        onClick={handleConfirmRequest}
                                        isDisabled={selectedTime.location !== '' ? true : false}
                                    />
                                </div>
                                <div className="divider"></div>
                                <div className="">
                                    <p className="mb-0 confirm-message">You will confirm appointment next</p>
                                </div>
                                <div className="selected-datetime-content mx-auto">
                                    <p className="mb-0 selected-datetime">
                                        {(calenderValue || today).toLocaleString('en-US', {
                                            weekday: 'short',   // 'Tue'
                                            month: 'long',      // 'March'
                                            day: 'numeric',     // '11'
                                        })}  {selectedTime.time ? 'at ' + selectedTime.time : ''}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isFullScreen && (
                <div className="calendar-fullscreen-overlay">
                    <div className="calendar-fullscreen-content">
                        <button className="close-button circle-btn" onClick={closeFullScreen}>
                            <Image imgUrl={CloseIcon} altText={'close'} className={''} />
                        </button>
                        <h2 className="calendar-title">Choose a day and time</h2>
                        <div className="calendar-container doctor-profile margin-y-50">
                            <DatePicker
                                onChange={(date) => calenderOnChange(date)}
                                selected={isChangeMonth ? checkDate(selectedDate) ? '' : selectedDate : checkDate(calenderValue) ? '' : calenderValue}
                                inline
                                filterDate={(date) => !isDateDisabled(date)} // Disable specific dates
                                dayClassName={dayClassName} //
                                highlightDates={highlightedDates}
                                calendarStartDay={0}
                                locale="it"
                                onMonthChange={(date) => {
                                    const fakeEvent = { preventDefault: () => console.log("Prevented default action") };
                                    handleMonthChange(fakeEvent, date);
                                }}
                                minDate={new Date()}
                            />
                        </div>
                        {isAddressTime && (
                            <div className="">
                                <>
                                    {doctorAvailability?.availableSlots?.map((availability, index) => (
                                        <>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <Image
                                                    imgUrl={MarkLocationIcon}
                                                    altText="mark location"
                                                    className="me-3"
                                                />
                                                <p className="mb-0 location">{availability.name}</p>
                                            </div>

                                            <div className="justify-content-between margin-y-14 slot slot-scroll">
                                                {availability?.slots.map((time, timeIndex) => (
                                                    <span
                                                        key={timeIndex}
                                                        className={`badge ${selectedTime.location === 'Surgery' && selectedTime.time === time.startTime
                                                            ? 'badge-selected badge-primary'
                                                            : ''
                                                            }`}
                                                        onClick={() => handleSelectTime('Surgery', time.startTime)}
                                                    >
                                                        {time.startTime}
                                                    </span>
                                                ))}
                                            </div>
                                        </>
                                    ))}
                                </>
                            </div>
                        )}

                    </div>
                </div>
            )}

            {isReview && (
                <>
                    <Reviews closeReviewScreen={closeReviewScreen} reviewsProgressList={reviewsProgress} reviews={reviewsList} />
                </>

            )}
        </div>
    );
};

export default DoctorProfile;